import React from 'react';

const TopLeftRibbon = () => (
  <svg width="240" height="240" viewBox="0 0 240 240" fill="none" className="absolute top-0 left-0 z-0 opacity-20 pointer-events-none">
    {/* Geometric Abstract Ribbon */}
    <polygon points="0,0 240,0 0,240" fill="url(#grad1)" />
    <polygon points="0,0 180,0 0,180" fill="url(#grad2)" />
    <polygon points="0,0 120,0 0,120" fill="#6D4CFF" />
    <polygon points="0,0 60,0 0,60" fill="#2D8CFF" />
    
    <defs>
      <linearGradient id="grad1" x1="0" y1="0" x2="240" y2="240" gradientUnits="userSpaceOnUse">
        <stop stopColor="#6D4CFF" />
        <stop offset="1" stopColor="#2D8CFF" stopOpacity="0" />
      </linearGradient>
      <linearGradient id="grad2" x1="0" y1="0" x2="180" y2="180" gradientUnits="userSpaceOnUse">
        <stop stopColor="#2D8CFF" />
        <stop offset="1" stopColor="#1A2340" stopOpacity="0" />
      </linearGradient>
    </defs>
  </svg>
);

const BottomRightRibbon = () => (
  <svg width="240" height="240" viewBox="0 0 240 240" fill="none" className="absolute bottom-0 right-0 z-0 opacity-20 pointer-events-none">
    {/* Geometric Abstract Ribbon Mirrored for Bottom Right */}
    <polygon points="240,240 0,240 240,0" fill="url(#grad3)" />
    <polygon points="240,240 60,240 240,60" fill="url(#grad4)" />
    <polygon points="240,240 120,240 240,120" fill="#6D4CFF" />
    <polygon points="240,240 180,240 240,180" fill="#2D8CFF" />
    
    <defs>
      <linearGradient id="grad3" x1="240" y1="240" x2="0" y2="0" gradientUnits="userSpaceOnUse">
        <stop stopColor="#6D4CFF" />
        <stop offset="1" stopColor="#2D8CFF" stopOpacity="0" />
      </linearGradient>
      <linearGradient id="grad4" x1="240" y1="240" x2="60" y2="60" gradientUnits="userSpaceOnUse">
        <stop stopColor="#2D8CFF" />
        <stop offset="1" stopColor="#1A2340" stopOpacity="0" />
      </linearGradient>
    </defs>
  </svg>
);

const CertificateBorder = () => {
  return (
    <>
      {/* Outer Border (3px Purple) */}
      <div className="absolute inset-[24px] border-[3px] border-[#6D4CFF] z-10 pointer-events-none"></div>
      
      {/* Inner Border (1px Light Gray) */}
      <div className="absolute inset-[32px] border-[1px] border-[#E5E7EB] z-10 pointer-events-none"></div>
      
      {/* Premium Abstract Corner Decorations */}
      <TopLeftRibbon />
      <BottomRightRibbon />
    </>
  );
};

export default CertificateBorder;
